import React, { useRef, forwardRef, useImperativeHandle } from "react";
import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';
import { audios } from "../../../assets/assets";

gsap.registerPlugin(useGSAP);

const InteractUI = forwardRef(({ label = "Step", order = 0, totalSteps = 4, indication = "Click to interact" }, ref) => {
  const uiRef = useRef();
  const activeStepRef = useRef();
  const timelineRef = useRef();

  useGSAP(() => {
    const liquidAudio = new Audio(audios.piano);
    liquidAudio.play().catch(console.warn);

    const tl = gsap.timeline();
    tl.fromTo(
      uiRef.current,
      { opacity: 0, scale: 2 },
      { opacity: 1, scale: 1, duration: 0.8, ease: "power2.out" }
    );
    tl.to(
      activeStepRef.current,
      { opacity: 1, transform: "translate(20px, -50%)", duration: 0.2, ease: "power2.out" },
      "+=0.2"
    );
    timelineRef.current = tl;
  }, []);

  useImperativeHandle(ref, () => ({
    exit: () => {
      console.log("👋 interactUI.exit() triggered");
      console.trace("👋 interactUI.exit() triggered");
      if (timelineRef.current) {
        timelineRef.current.reverse();
        timelineRef.current.eventCallback("onReverseComplete", () => {
          import("../../store/flowStore").then(({ default: useFlowStore }) => {
            useFlowStore.setState({ showInteractUI: false });
          });
        });
      }
    },
  }));

  return (
    <div className="interactUI" ref={uiRef}>
      <div className="interactUI__activeStep" ref={activeStepRef}>
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`interactUI__activeStep__item ${index === order ? "active" : ""}`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M8.19727 2.26172C8.97697 0.923313 10.8742 0.881817 11.7236 2.13672L11.8027 2.26172L13.1748 4.61719C13.5836 5.31911 14.2516 5.8298 15.0312 6.04199L15.1885 6.08105L17.8535 6.65723C19.3671 6.98521 19.993 8.77703 19.0625 9.97266L18.9678 10.0869L17.1514 12.1201C16.6102 12.7258 16.3301 13.5182 16.3691 14.3252L16.3818 14.4873L16.6562 17.1992C16.8123 18.7403 15.3018 19.8898 13.877 19.374L13.7393 19.3184L11.2441 18.2197C10.5008 17.8922 9.66072 17.8716 8.90527 18.1582L8.75586 18.2197L6.26074 19.3184C4.84336 19.943 3.28394 18.862 3.33398 17.3477L3.34375 17.1992L3.61816 14.4873C3.69999 13.6791 3.46015 12.8731 2.9541 12.2432L2.84863 12.1201L1.03223 10.0869C0.000432692 8.93189 0.547298 7.11465 2.00293 6.69434L2.14648 6.65723L4.81152 6.08105C5.60535 5.90912 6.29752 5.4317 6.74023 4.75586L6.8252 4.61719L8.19727 2.26172Z" fill={index === order ? "#3A67F1" : "#FFF"} stroke={index === order ? "#FEFEFE" : ""}/>
              <path d="M9.13589 8.84638C9.52162 8.18412 10.4784 8.18411 10.8641 8.84638L11.0713 9.20217C11.2126 9.44477 11.4494 9.6168 11.7238 9.67622L12.1262 9.76336C12.8753 9.92556 13.1709 10.8355 12.6603 11.407L12.3859 11.714C12.1989 11.9234 12.1084 12.2017 12.1367 12.4811L12.1782 12.8907C12.2554 13.6532 11.4814 14.2156 10.78 13.9065L10.4032 13.7405C10.1463 13.6273 9.85366 13.6273 9.59675 13.7405L9.21997 13.9065C8.51864 14.2156 7.7446 13.6532 7.82181 12.8907L7.86329 12.4811C7.89157 12.2017 7.80113 11.9234 7.61406 11.714L7.33973 11.407C6.82907 10.8355 7.12472 9.92556 7.87378 9.76336L8.27619 9.67622C8.55058 9.6168 8.78736 9.44477 8.92866 9.20217L9.13589 8.84638Z" fill={index === order ? "#FEFEFE" : "#3A67F1"}/>
            </svg>
            {index === order && <span>{label}</span>}
          </div>
        ))}
      </div>
      <h1 className="interactUI__title">{indication}</h1>
    </div>
  );
});

export default InteractUI;
